// Added by Sejune Oh on 2019-06-27
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Theme } from '@material-ui/core'
import { Property } from 'csstype'
import { GREY_COLOR } from '../Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) => ({
    Wrapper: {
        background: '#303030',
        maxWidth: '640px',
        minWidth: '450px',
        position: 'relative' as Property.Position,
    },
    InputWrapper: {
        padding: `0 ${theme.spacing()}px ${theme.spacing()}px ${theme.spacing()}px`,
    },
    HeaderWrapper: {
        color: '#fff',
        padding: '8px',
        fontSize: '16px',
        margin: `${theme.spacing()}px`,
        borderBottom: `1px solid ${GREY_COLOR}`,
        fontWeight: 'bold' as Property.FontWeight,
    },
    BtnWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: `0 ${theme.spacing() * 2}px ${theme.spacing()}px ${theme.spacing() * 2}px`,
    },
    Snackbar: {
        position: 'absolute' as Property.Position,
        bottom: '-55px',
        left: '0',
        right: '0',
        transform: 'translateX(0)',
    },
    SnackbarContent: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
    },
})

export default styles
